import { InjectionToken, Provider } from '@angular/core';

/**
 * Router path of the app's email-verification screen, e.g. `/auth/verify-email`.
 *
 * Step-up falls back to an email OTP, which the BE refuses to send to an
 * unverified address (403 `EMAIL_VERIFICATION_REQUIRED`). When that happens the
 * dialog offers a way out instead of a retry that can't succeed — but only if
 * the host app has such a screen, so this is optional and the lib stays
 * app-agnostic.
 */
export const STEP_UP_VERIFY_EMAIL_ROUTE = new InjectionToken<string>(
  'STEP_UP_VERIFY_EMAIL_ROUTE'
);

export function provideStepUpVerifyEmailRoute(path: string): Provider {
  return { provide: STEP_UP_VERIFY_EMAIL_ROUTE, useValue: path };
}
